/* Cart Drawer — assets/cart-drawer.js */
(function () {
  'use strict';

  var settings = window.cartDrawerSettings || {};

  function getDrawer() {
    return document.getElementById('CartDrawer');
  }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }

  function renderDrawer(html) {
    // html is the full rendered section markup for 'cart-drawer'; swap it in wholesale
    // so item list, subtotal, and item_count are always in sync with the server — no stale-state bugs.
    var temp = document.createElement('div');
    temp.innerHTML = html;
    var newDrawer = temp.querySelector('#CartDrawer');
    var oldDrawer = getDrawer();
    if (newDrawer && oldDrawer && oldDrawer.parentNode) {
      var wasOpen = oldDrawer.classList.contains('is-open');
      oldDrawer.parentNode.replaceChild(newDrawer, oldDrawer);
      if (wasOpen) {
        newDrawer.classList.add('is-open');
        newDrawer.setAttribute('aria-hidden', 'false');
      }
      bindDrawerEvents();
      updateCartCountBubbles();
    }
  }

  function updateCartCountBubbles() {
    var countEl = document.querySelector('[data-cart-count]');
    var drawer = getDrawer();
    if (!countEl || !drawer) return;
    var titleEl = drawer.querySelector('.cart-drawer__title');
    if (!titleEl) return;
    var match = titleEl.textContent.match(/\((\d+)\)/);
    if (match) countEl.textContent = match[1];
  }

  function refreshCartSections() {
    fetch((settings.cartUrl || '/cart') + '?sections=cart-drawer')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data['cart-drawer']) renderDrawer(data['cart-drawer']);
      })
      .catch(function () {});
  }

  function changeLine(key, quantity) {
    return fetch(settings.cartChangeUrl || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function () { refreshCartSections(); });
  }

  function bindDrawerEvents() {
    var drawer = getDrawer();
    if (!drawer) return;

    drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    drawer.querySelectorAll('[data-cart-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.cart-drawer__item');
        var valueEl = item.querySelector('[data-cart-qty-value]');
        var current = parseInt(valueEl.textContent, 10) || 1;
        var next = Math.max(0, current - 1);
        changeLine(btn.dataset.key, next);
      });
    });

    drawer.querySelectorAll('[data-cart-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.cart-drawer__item');
        var valueEl = item.querySelector('[data-cart-qty-value]');
        var current = parseInt(valueEl.textContent, 10) || 1;
        changeLine(btn.dataset.key, current + 1);
      });
    });

    drawer.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeLine(btn.dataset.key, 0);
      });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  document.addEventListener('cart-drawer:open', openDrawer);
  document.addEventListener('cart-drawer:render', function (e) {
    if (e.detail && e.detail.html) renderDrawer(e.detail.html);
  });

  // Any element on the theme (header cart icon, etc.) can open the drawer with data-cart-drawer-open
  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('[data-cart-drawer-open]');
    if (openTrigger) {
      e.preventDefault();
      refreshCartSections();
      openDrawer();
    }
  });

  bindDrawerEvents();
})();
